import React from 'react';
import { Flex } from 'antd';

import { SettingCard } from '../components/SettingCard';
import { getVisibleSettings } from '../utils/options';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

export const SettingsContainer = () => {
    const current = useAppSelector(selectShopCurrent);
    const settings = getVisibleSettings(current.type);

    return (
        <Flex gap={16} wrap={'wrap'}>
            {settings.map(setting => (
                <SettingCard key={setting.key} {...setting} />
            ))}
        </Flex>
    );
};
